import { render } from "./EditPriceModal.vue?vue&type=template&id=12dd3e38&scoped=true"
import script from "./EditPriceModal.vue?vue&type=script&lang=js"
export * from "./EditPriceModal.vue?vue&type=script&lang=js"

import "./EditPriceModal.vue?vue&type=style&index=0&id=12dd3e38&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd3e38"]])

export default __exports__